import React from 'react'
import "./stayInTouchCard.css";
import StayInTouchCarousel from './StayInTouchCarousel';


const stayInTouchCard = ({ onOpenStayInTouchModal }) => {
    return (
        <div className="full-container w-full bg-[rgba(242, 242, 242, 1)] flex justify-center items-center py-10 md:py-16" >

            <div className="card-container bg-[rgba(242, 242, 242, 1)] pb-8 md:py-4 md:w-[95%] w-[90%] flex flex-col-reverse md:flex-row rounded-[2.8rem] md:p-14 p-6 justify-center items-center gap-6" >

                {/* Card Left Part */}
                <div className="stayInTouchCard-left-part md:basis-[55%] text-[var(--purple-blue)]">

                    {/* Heading Part */}
                    <div className="stayinTouchCard-heading md:text-left 2xl:text-6xl  md:text-5xl text-[2.5rem] font-ClashGrotesk  font-medium md:pb-10 mb-3 w-[75%] md:w-auto">Stay in touch with us!</div>

                    {/* Description and button */}
                    <div className="flex flex-col md:items-start text-center font-manrope">
                        <p className="stayInTouch-card-description 2xl:text-2xl md:text-xl text-base text-left font-medium mb-7 md:w-[92%]">Sign up for updates on email or WhatsApp, and share your interests. We’ll make sure you get the updates you’ll love.</p>
                        <button onClick={onOpenStayInTouchModal} className="stayInTouch-card-btn 2xl:text-xl md:text-lg text-sm bg-[var(--purple-blue)]  py-4 md:w-[60%]  px-14 text-[var(--white)] rounded-xl text-center">Sign Up for Updates</button>
                    </div>
                </div>

                {/* Card Right Part */}
                <div className="stayInTouchCard-right-part md:basis-1/2 md:w-1/2 w-full flex  justify-center items-center mb-6 md:mb-0 ">



                    <div className="md:w-[90%] w-full flex flex-col  items-center justify-center pt-5 md:pt-0">

                        <StayInTouchCarousel></StayInTouchCarousel>
                    </div>



                </div>

            </div>

        </div>
    )
}

export default stayInTouchCard;
